// Constants and Utils
import {
  downloadFile,
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";
import { getToken } from "../utils/token";
import { roundUpNearestInteger } from "../common-utils/number-utils/NumberUtils";

// Urls
import {
  approxOtsForCityUrl,
  downloadCityMediasPdfReportsZipUrl,
  downloadCityMediasSinglePdfReportUrl,
  downloadCityPdfReportUrl,
  getCitySummaryUrl,
} from "../urls/CampaignCityReportURL";

export async function getCitySummaryData(campaignId, cityId) {
  // getting urls
  const cityOverviewUrl = getCitySummaryUrl
    .replace(":campaignId", campaignId)
    .replace(":cityId", cityId);

  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendGetRequest(cityOverviewUrl, {}, true, headerParams);
}

export async function approxMavinOts(campaignId, cityId) {
  // Request Headers
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    approxOtsForCityUrl
      .replace(":campaignId", campaignId)
      .replace(":cityId", cityId),
    {},
    true,
    "PUT",
    headerParams
  );
}

export async function downloadCityPdfReportFn(
  campaignId,
  cityId,
  mapCenter,
  mapZoom,
  isSentViaEmail = false,
  emailIds = []
) {
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  // string => "lat,lng"
  const centerAsString = mapCenter.join(",");

  // round off zoom
  const roundOffZoom = roundUpNearestInteger(mapZoom);

  // params
  const params = {
    center: centerAsString,
    zoom: roundOffZoom,
    isSentViaEmail: isSentViaEmail,
  };

  // sending reports via email
  if (isSentViaEmail) {
    params.emailIds = emailIds.join(",");
  }

  return downloadFile(
    downloadCityPdfReportUrl
      .replace(":campaignId", campaignId)
      .replace(":cityId", cityId),
    true,
    headerParams,
    params
  );
}

export async function downloadCityMediasPdfReportsZipFn(
  campaignId,
  cityId,
  radius,
  isSentViaEmail = false,
  emailIds = []
) {
  // Request Headers
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  const radiusInKm = radius ? radius / 1000 : 1;

  // params
  const params = {
    radiusInKm: radiusInKm,
    isSentViaEmail: isSentViaEmail,
  };

  // sending reports via email
  if (isSentViaEmail) {
    params.emailIds = emailIds.join(",");
  }

  return downloadFile(
    downloadCityMediasPdfReportsZipUrl
      .replace(":campaignId", campaignId)
      .replace(":cityId", cityId),
    true,
    headerParams,
    params
  );
}

export async function downloadCityMediasSinglePdfReportFn(
  campaignId,
  cityId,
  radius,
  isSentViaEmail = false,
  emailIds = []
) {
  // Request Headers
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  const radiusInKm = radius ? radius / 1000 : 1;

  // params
  const params = {
    radiusInKm: radiusInKm,
    isSentViaEmail: isSentViaEmail,
  };

  // sending reports via email
  if (isSentViaEmail) {
    params.emailIds = emailIds.join(",");
  }

  return downloadFile(
    downloadCityMediasSinglePdfReportUrl
      .replace(":campaignId", campaignId)
      .replace(":cityId", cityId),
    true,
    headerParams,
    params
  );
}
